// `/` focuses the page's search field, the convention every list UI shares.
//
// The hook goes on the *form*, so it works for any page that renders
// `search_field/1` without each of them wiring up a shortcut.
//
// Gated on nothing else having focus, which covers the search field itself: a
// slash typed into a KQL query is a slash, not a shortcut.
import { isTypingInExternalInput } from "../utils/keyboard";

export const FocusSearch = {
  mounted() {
    this.onKeydown = (event) => {
      if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey) return;
      if (isTypingInExternalInput(null)) return;

      const field = this.el.querySelector("input[type=search]");
      if (!field) return;

      // Otherwise the slash that got us here lands in the field.
      event.preventDefault();
      field.focus();
      field.select();
    };

    window.addEventListener("keydown", this.onKeydown);
  },

  destroyed() {
    window.removeEventListener("keydown", this.onKeydown);
  },
};
